import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractAvatarsService } from '../../modules/contracts/services/contract-avatar.service';
import { SafeUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { ProfileCardModalComponent } from '../modal/profile-card-modal/profile-card-modal.component';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-contract-avatar',
    templateUrl: './contract-avatar.component.html',
    styleUrl: './contract-avatar.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class AppContractAvatarComponent {
  @Input() userGuid:string = ''
  @Input() checkedState:boolean = false
  avatarSizeDefault:string = '42px'
  @Input() avatarSize:string = this.avatarSizeDefault
  public fontSize:number = 16
  private subs:Subscription = new Subscription()
  public imgAvatar:SafeUrl|undefined 
  public genericAvatar:{background:string,text:string}|undefined 
  constructor (
    private dialog :MatDialog,
    private contractAvatarsService :ContractAvatarsService,
    private cds:ChangeDetectorRef
  ){}
  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
  ngOnInit(): void {
    this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(()=>this.setAvatarImg()))
  }

  ngOnChanges(): void {
    this.setAvatarImg()
  }
  setAvatarImg() {
    this.imgAvatar = this.contractAvatarsService?.contractAvatarMap?.get(this.userGuid)?.img
    this.imgAvatar? null : this.genericAvatar = this.contractAvatarsService.contractGenericAvatarMap?.get(this.userGuid)
    this.cds.detectChanges()
  }
  openProfile(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    let dialogRef = this.dialog.open(ProfileCardModalComponent,{panelClass:'avatar-dialog-box'})
    dialogRef.componentInstance.memberGuid = this.userGuid
    dialogRef.componentInstance.modalView = false
  }
}
